export const APP_DISPLAY_NAME =
  import.meta.env.VITE_APP_NAME?.trim() || 'Kartly Store Admin'
